import React from 'react';
import Banner from '../../../components/Bannersection/banner';
import { Helmet } from "react-helmet";
import { FiUsers, FiClock, FiDollarSign, FiZap, FiMapPin, FiCamera, FiMap } from "react-icons/fi";
import Faq from '../../../components/Faq/faq';
import Boxcard from '../../../components/Cardesection/boxcard';
import PricingSection from "../../../components/PricingSection/PricingSection";

const pagename = [{ pagetitle: "Boox365 HRMS", subtitle: "Products" }];

const faqitem = [
  { Faq_id: "collapseone", data_bs_target: "#collapseone", question: "How does Boox365 HRMS track attendance?", answer: "Our system supports multiple tracking methods, including web-based check-ins, mobile geolocation, and integration with biometric devices." },
  { Faq_id: "collapsetwo", data_bs_target: "#collapsetwo", question: "Is the payroll module compliant with Australian tax laws?", answer: "Yes, our payroll engine is designed to handle automated calculations for PAYG withholding, superannuation, and STP reporting in line with ATO requirements." },
  { Faq_id: "collapseThree", data_bs_target: "#collapseThree", question: "Can employees access their own data?", answer: "Yes, through our dedicated Employee Self-Service (ESS) portal, staff can view payslips, apply for leave, and update personal information." },
  { Faq_id: "collapsefour", data_bs_target: "#collapsefour", question: "Does it support recruitment tracking?", answer: "Yes, the recruitment module allows you to manage the entire hiring pipeline, from job posting to offer letter generation." }
];

function Boox365Hrms() {
  const features = [
    { icons: FiUsers, title: "Onboarding", description: "Seamlessly integrate new hires with automated documentation, training paths, and asset allocation. Reduce manual paperwork and provide a premium experience for every new employee." },
    { icons: FiClock, title: "Time & Attendance", description: "Automate time tracking and ensure accurate, timely salary disbursements every month. Manage shifts, overtime, and leave requests in real-time with comprehensive approval workflows." },
    { icons: FiDollarSign, title: "Payroll & Benefits", description: "Process monthly payroll with a single click. Our engine handles PAYG withholding, superannuation contributions, and STP reporting automatically, ensuring 100% accuracy and ATO compliance." },
    { icons: FiMapPin, title: "Roaming Profile", description: "Enable employees who work across multiple locations to clock in and out freely throughout the day. Perfect for field staff, delivery agents, and on-site contractors who are always on the move." },
    { icons: FiCamera, title: "Face Verification", description: "Ensure every attendance entry is genuine with built-in face verification at the point of check-in. Employees capture a live photo during clock-in, eliminating buddy punching and proxy attendance." },
    { icons: FiMap, title: "GPS Tracking", description: "Capture the exact GPS coordinates of your employees at the moment they clock in or out. Admins can verify whether employees are at the designated work site before approving attendance." }
  ];

  return (
    <div>
      <Helmet>
        <title>Boox365 HRMS | Cloud HR Software for Australian Teams | DGi WORX</title>
        <meta name="description" content="Empower your workforce with Boox365 HRMS. An intelligent, cloud-first platform for payroll, time-tracking, and talent management compliant with Australian workplace laws." />
        <meta property="og:url" content="https://dgiworx.com.au/hr-boox" />
        <link rel="canonical" href="https://dgiworx.com.au/hr-boox" />
        <link rel="alternate" hreflang="en-au" href="https://dgiworx.com.au/" />
      </Helmet>

      <Banner items={pagename} />

      <section className="about-area tp-about-two py-100">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <div className="tp-about-two-wrap mt-10">
                <div className="tp-about-two-thumb">
                  <div className='tp-about-circle'>
                    <div className='tp-about-circle-two'>
                      <img src="/assets/img/product/boox_365.webp" alt="Boox365 HRMS" loading='lazy' />
                    </div>
                  </div>
                </div>
                <div className="tp-about-two-thumb-shape tp-thumb-common fix">
                  <div className="tp-thumb-common-overlay"></div>
                  <img src="/assets/img/product/boox_365.webp" alt="HRMS" loading='lazy' />
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="tp-about-two-wrapper mb-10">
                <div className="tp-section mb-40">
                  <span className="tp-section-sub-title">SMART HUMAN CAPITAL MANAGEMENT</span>
                  <h2 className="tp-section-title">Next-Gen HR Operations</h2>
                  <p>Boox365 HRMS is an intelligent, cloud-first platform built to streamline and automate human resource workflows. We eliminate paperwork and replace manual processes with smart technology â€” empowering your HR professionals to focus on building a more engaged and productive organisation.</p>
                </div>
                <div>
                  <ul className="tp-about-one-list">
                    <li>
                      <span><img src="/assets/img/icon/check-list.png" alt="" loading="lazy" /></span>
                      <strong>Cloud-Native Employee Self-Service</strong> â€“ Empower employees to manage data anywhere.
                    </li>
                    <li>
                      <span><img src="/assets/img/icon/check-list.png" alt="" loading="lazy" /></span>
                      <strong>Automated Payroll & ATO Compliance</strong> â€“ 100% accurate salary processing with STP reporting.
                    </li>
                    <li>
                      <span><img src="/assets/img/icon/check-list.png" alt="" loading="lazy" /></span>
                      <strong>Zero-Trust Secure Document Vault</strong> â€“ Safely store employee records in the cloud.
                    </li>
                    <li>
                      <span><img src="/assets/img/icon/check-list.png" alt="" loading="lazy" /></span>
                      <strong>Real-time Superannuation Tracking</strong> â€“ Automated super contributions and compliance alerts.
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="feature-area py-50 p-relative">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-10 col-md-12">
              <div className="tp-section text-center mb-50">
                <span className="tp-section-sub-title">FUNCTIONAL PILLARS</span>
                <h2 className="tp-section-title">HR Excellence Modules</h2>
                <p className="col-lg-10 mx-auto">
                  Transform your human resources operations with our integrated modules designed for every stage of the employee lifecycle.
                </p>
              </div>
            </div>
          </div>
          <Boxcard item={features} />
        </div>
        <div className="tp-feature-shape">
          <div className="tp-feature-shape-one w-img">
            <img src="/assets/img/feature/one/features-bg.png" alt="Elevating Possibilities" loading="lazy" />
          </div>
        </div>
      </section>

      {/* <PricingSection productKey="hrms" title="HRMS Plans & Pricing" /> */}
      <Faq items={faqitem} />
    </div>
  );
}

export default Boox365Hrms;
